import React, { Component } from "react";
import { Link, Route, withRouter, Switch, Redirect } from "react-router-dom";

class MainPanelMobile extends Component {

    render(){
        return(
            <div>Mobile</div>
        )
    }
}

export default withRouter(MainPanelMobile);